import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m16.5 12 2 2v2h-5v6l-1 1-1-1v-6h-5v-2l2-2V5h-1V3h10v2h-1zm-7.15 2h6.3l-1.15-1.15V5h-4v7.85z"
    }, null, -1)
  ]))]))
}
export default { render: render }